// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"ad40150f","455":"529ddf5a","488":"a511ceea","977":"b584b783"}[chunkId] + ".chunk.js";
};